import React from "react";
import ContentLoader from "react-content-loader";

const EditContactFormLoader = (props) => {
  return (
    <div style={{ marginLeft: props.detailProfileAsider ? 15 : "" }}>
      <ContentLoader width={"35%"} style={{ height: 40, marginTop: 20 }}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="25" />
      </ContentLoader>
      <ContentLoader width={"90%"} style={{ height: 40 }}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="25" />
      </ContentLoader>

      <ContentLoader width={"35%"} style={{ height: 40, marginTop: 10 }}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="25" />
      </ContentLoader>
      <ContentLoader width={"90%"} style={{ height: 40 }}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="25" />
      </ContentLoader>

      <ContentLoader width={"35%"} style={{ height: 40, marginTop: 10 }}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="25" />
      </ContentLoader>
      <ContentLoader width={"90%"} style={{ height: 40 }}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="25" />
      </ContentLoader>
    </div>
  );
};
export default EditContactFormLoader;
